import React from "react"
import { AuthProvider } from "./src/context/AuthContext"
import 'bootstrap/dist/css/bootstrap.min.css';
import Parse from 'parse'

// Inicializar Parse
Parse.initialize("2hB1TeweuD");
Parse.serverURL = "https://aircab5.herokuapp.com/parse";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
)

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location
  // lista de rutas donde queremos resetear el scroll
  const scrollToTopRoutes = ['/home', '/history', '/travelBooking']
  if (scrollToTopRoutes.indexOf(pathname) !== -1) {
    window.scrollTo(-10, -10)
  }

  return false
}